module.exports = {"navigation":[{"text":"Releases","url":"#releases"},{"text":"Contact","url":"#contact"}]}